var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownSUnfill = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_28207_5911)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.70971 6.77367C8.54627 6.77367 8.38283 6.71346 8.2538 6.58443L6.55917 4.8898L4.86455 6.58443C4.61508 6.83388 4.20218 6.83388 3.95272 6.58443C3.70326 6.33496 3.70326 5.92206 3.95272 5.6726L6.10326 3.52206C6.35272 3.2726 6.76563 3.2726 7.01508 3.52206L9.16563 5.6726C9.41508 5.92206 9.41508 6.33496 9.16563 6.58443C9.03659 6.71346 8.87315 6.77367 8.70971 6.77367Z",
  fill: "#121212"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.55922 16.6663C6.20653 16.6663 5.91406 16.3739 5.91406 16.0212V3.97817C5.91406 3.62548 6.20653 3.33301 6.55922 3.33301C6.91191 3.33301 7.20439 3.62548 7.20439 3.97817V16.0212C7.20439 16.3739 6.91191 16.6663 6.55922 16.6663Z",
  fill: "#121212"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4381 16.6662C13.2747 16.6662 13.1112 16.606 12.9822 16.477L10.8316 14.3264C10.5822 14.077 10.5822 13.664 10.8316 13.4146C11.0811 13.1652 11.494 13.1652 11.7435 13.4146L13.4381 15.1093L15.1327 13.4146C15.3822 13.1652 15.795 13.1652 16.0446 13.4146C16.294 13.664 16.294 14.077 16.0446 14.3264L13.894 16.477C13.7649 16.606 13.6015 16.6662 13.4381 16.6662Z",
  fill: "#121212"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4381 16.6663C13.0854 16.6663 12.793 16.3739 12.793 16.0212V3.97817C12.793 3.62548 13.0854 3.33301 13.4381 3.33301C13.7909 3.33301 14.0833 3.62548 14.0833 3.97817V16.0212C14.0833 16.3739 13.7908 16.6663 13.4381 16.6663Z",
  fill: "#121212"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28207_5911"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13.3333,
  height: 13.3333,
  fill: "white",
  transform: "translate(3.33203 3.33301)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownSUnfill);
export { ForwardRef as ReactComponent };